<template>
    <div>
        <asset-navbar :filterMarket="filterMarket">
            <template v-slot:title>
                <span v-if="market" class="ml-1">{{ market }} disabled assets</span>
                <span v-else class="ml-1">???</span>
            </template>
            <template v-slot:subTitle>
            </template>
        </asset-navbar>

        <div v-if="filterMarket && assets.length">
            <rounded-container>
                <template v-slot:title>
                    disabled
                    <span class="text-secondary">{{ disabledAssets.length }}</span>
                </template>

                <list-assets-table :assetList="disabledAssets" />
            </rounded-container>
        </div>
        <div v-else>
            loading screen
        </div>
    </div>
</template>

<script>

import ListAssetsTable from '../components/asset/ListAssetsTable.vue';
import AssetNavbar from '../components/AssetNavbar.vue';
import RoundedContainer from '../components/style/RoundedContainer.vue';

export default {
    name: 'DisabledAssets',
    components: {
        ListAssetsTable,
        RoundedContainer,
        AssetNavbar,
    },
    props: ['market', 'assets'],
    data() {
        return {
            filterMarket: '',
        }
    },
    created() {
        this.filterMarket = this.market;
        // /api/assets is the only endpoint that ships disabled assets
        this.$store.dispatch('loadAssetList');
    },
    computed: {
        disabledAssets() {
            return this.assets.filter(asset =>
                asset.market === this.filterMarket && asset.status === 'disabled');
        },
    },
    watch: {
        $route(to) {
            // force content refresh when switching props
            this.filterMarket = to.params.market;
        }
    }
};
</script>
